<template>
  <div
    class="overflow-hidden rounded-xl border"
    :class="[
      mode === 'dark'
        ? 'border-dark-border bg-dark-sidebar'
        : 'border-border-10 bg-white-100',
      isHidden ? 'xl:hidden' : '',
    ]"
  >
    <div class="without-scrollbar overflow-x-auto">
      <table class="table" :class="[mode === 'dark' ? 'dark-table' : '']">
        <thead>
          <tr>
            <th
              v-for="(column, key) in columns"
              :key="key"
              :class="column.classes"
            >
              <span v-if="column.name">{{ column.name }}</span>
              <span v-else>
                <slot v-if="$slots.checkbox" name="checkbox" />
              </span>
            </th>
          </tr>
        </thead>
        <tbody>
          <slot name="rows" />
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: "Table",
  props: {
    mode: String,
    columns: {
      type: Array,
      default: () => [
        {
          name: "",
          classes: "",
        },
      ],
    },
    isHidden: {
      type: Boolean,
      default: true,
    },
  },
};
</script>
